
import formatByCountry from "@/app/infrastructures/misc/common-library/FormatByCountry";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { HandoverV2Detail } from "@/domain/entities/HandoverV2";
import { OptionsClass, Snackbar } from "@/domain/entities/MainApp";
import { Options, prop, Vue } from "vue-class-component";

class Props {
  isEmpty = prop<boolean>({ default: true, type: Boolean });
  isLoading = prop<boolean>({ default: false });
  lastScanRow = prop<HandoverV2Detail>({
    default: () => new HandoverV2Detail(),
    type: HandoverV2Detail
  });
  rows = prop<HandoverV2Detail[]>({ default: () => [], type: Array });
  eligibleVendorList = prop<HandoverV2Detail[]>({
    default: () => [],
    type: Array
  });
}

@Options({
  emits: ["update:lastScanRow", "process", "clear-all"],
  watch: {
    openChangeVendor(newVal) {
      if (newVal) {
        this.newVendor = new OptionsClass({
          id: this.lastScanRow.destinationPartnerId,
          name: this.lastScanRow.vendorName,
          value: this.lastScanRow.vendorCode,
          key: this.lastScanRow.destinationPartnerType, // key as type
          isChip: this.lastScanRow.apiIntegration,
          chipLabel: "API",
          chipStyle:
            "rounded-full bg-red-lp-3000 px-2 py-0.5 font-medium text-xs text-red-lp-2400"
        });
      }
    }
  }
})
class ScanSidebarEntityPanel extends Vue.with(Props) {
  get summary() {
    const totalStt = formatByCountry(this.rows.length, { type: "quantity" });
    const totalKoli = formatByCountry(
      this.rows.reduce((sum, item) => sum + item.stt.sttTotalPiece, 0),
      { type: "quantity" }
    );
    const totalGrossWeight = formatByCountry(
      this.rows.reduce((sum, item) => sum + item.stt.sttGrossWeight, 0),
      { type: "weight" }
    );
    const totalVolumeWeight = formatByCountry(
      this.rows.reduce((sum, item) => sum + item.stt.sttVolumeWeight, 0),
      { type: "weight" }
    );

    return {
      totalStt,
      totalKoli,
      totalGrossWeight,
      totalVolumeWeight
    };
  }

  get disabledProcess() {
    return this.isVendorInternal && !this.lastScanRow.remarks;
  }

  openChangeVendor = false;
  newVendor = new OptionsClass();

  get isVendorInternal() {
    return this.lastScanRow.vendorCode === "VENDORINTERNAL";
  }

  get vendorOptions() {
    const unique = new Map(
      this.eligibleVendorList.map((r) => [
        r.vendorCode,
        new OptionsClass({
          id: r.destinationPartnerId,
          name: r.vendorName,
          value: r.vendorCode,
          key: r.destinationPartnerType, // key as type
          isChip: r.apiIntegration,
          chipLabel: "API",
          chipStyle:
            "rounded-full bg-red-lp-3000 px-2 py-0.5 font-medium text-xs text-red-lp-2400",
          disabled: !r.isAvailable,
          reason: r.reason,
          reasonEn: r.reasonEn
        })
      ])
    );

    return [
      new OptionsClass({
        name: "Semua",
        value: ""
      }),
      ...unique.values()
    ];
  }
  onSelectVendor(item: OptionsClass) {
    this.newVendor = item;
  }

  optionReason(option: OptionsClass) {
    return this.$i18n.locale === "id"
      ? option.reason
      : option.reasonEn || option.reason;
  }

  onSaveChangeVendor() {
    this.$emit(
      "update:lastScanRow",
      new HandoverV2Detail({
        ...this.lastScanRow,
        vendorName: this.newVendor.name,
        vendorCode: this.newVendor.value,
        destinationPartnerCode: this.newVendor.value,
        destinationPartnerType: this.newVendor.key,
        destinationPartnerId: this.newVendor.id,
        apiIntegration: this.newVendor.isChip,
        remarks: this.isVendorInternal ? this.lastScanRow.remarks : ""
      })
    );
    this.openChangeVendor = false;

    MainAppController.setSnackbarData(
      new Snackbar({
        type: "success",
        message: this.$t("handoverV2.update.changeVendor.success")
      })
    );
    MainAppController.setAutoClose(true);
    MainAppController.setSnackbar(true);
  }
}
export default ScanSidebarEntityPanel;
